<template>
  <v-card>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        {{ $t('REPORTS.ACTIVITY_LOG') }}
      </v-card-title>

      <v-card-text>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="period | periodFormat"
              :label="$t('EREPORTER.PERIOD')"
              :rules="rules.period"
              :error-messages="errors.get('period')"
              append-icon="mdi-calendar"
              clearable
              readonly
              role="button"
              autocomplete="nope"
              v-bind="attrs"
              v-on="on"
              @click:clear="clear"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            type="month"
            :value="period"
            :max="datetimeNow"
            @change="setPeriod"
          ></v-date-picker>
        </v-menu>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" @click="getFile">
          {{ $t('BUTTON.EXPORT') }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import moment from 'moment';
import errors from '@/modules/_global/mixins/errors';
import { periodFormat, dateFormatBackend } from '@/modules/_global/filters';
import { ReportsService } from '@/services/reports.service';
import downloadFile from '@/modules/_global/mixins/download-file';
import { notEmpty } from '@/modules/_global/variables/rules';

export default {
  name: 'ActivityLog',

  filters: {
    periodFormat
  },

  mixins: [downloadFile, errors],

  data: () => ({
    valid: false,
    datetimeNow: '',
    period: '',
    rules: {
      period: [notEmpty]
    }
  }),

  created() {
    this.datetimeNow = moment().format('YYYY-MM-DD');
  },

  methods: {
    setPeriod(value) {
      this.period = value;
      this.errors.clear('period');
    },

    getFile() {
      return ReportsService.getActivityLogReport({
        period: dateFormatBackend(this.period)
      })
        .then(response => {
          this.downloadFile(
            response,
            `activityLog ${periodFormat(this.period)}.log`
          );
        })
        .catch(this.handleErrors);
    },

    clear() {
      this.period = null;
      this.errors.clear('period');
    }
  }
};
</script>
